module.exports = "/assets/packs/images/02b5fd7015f09bd891c402e056b7dac5.png";